import { render, staticRenderFns } from "./SizeInformationCreateOrUpdate.vue?vue&type=template&id=0486bacb&"
import script from "./SizeInformationCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./SizeInformationCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports